import { ImgHTMLAttributes } from 'react'
import { cn, createComponent } from '@lair-finance/util'
import { ValidatorIconMap, ValidatorId } from '@/domains/validator/config'

export type TokenSymbolProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string
  size?: number
  hasBorder?: boolean
}

export const TokenSymbol = createComponent<HTMLImageElement, TokenSymbolProps>(({ src, size, hasBorder = true, className, ...props }, ref) => {
  if (!hasBorder) {
    return <img src={src} ref={ref} {...props} width={size || props.width} height={size || props.height} className={cn('rounded-full', className)} />
  }

  return (
    <div className={cn('relative inline-flex-center', className)}>
      <img src={src} ref={ref} {...props} width={size || props.width} height={size || props.height} className={'rounded-full'} />
      <div className={'absolute inset-0 size-full rounded-full border border-greyscale-500'} />
    </div>
  )
}, 'TokenSymbol')

export type ValidatorSymbolProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  validatorId: ValidatorId
  size?: number
}

export const ValidatorSymbol = createComponent<HTMLImageElement, ValidatorSymbolProps>(({ validatorId, size, className, ...props }, ref) => {
  return (
    <img
      src={validatorId ? ValidatorIconMap[validatorId] : ''}
      ref={ref}
      {...props}
      width={size || props.width}
      height={size || props.height}
      className={cn('rounded-full border border-greyscale-500', className)}
    />
  )
}, 'ValidatorSymbol')
